import React from 'react';
import { Spinner } from 'react-bootstrap';

const Loading = ({ message = 'Chargement...' }) => {
    return (
        <div className="d-flex flex-column justify-content-center align-items-center py-5">
            <Spinner animation="border" role="status" className="mb-2" variant="primary">
                <span className="visually-hidden">Chargement...</span>
            </Spinner>
            <p className="text-muted">{message}</p>
        </div>
    );
};

export default Loading;